import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import RoutesPath from '../constants/routes-path';

import HomePage from '../pages/Home';
import NewTicketPage from '../pages/NewTicket';
import TicketPage from '../pages/Ticket';

import Analytics from './Analytics';
import SettingsPage from '../pages/Settings';

const Routes = () => (
    <BrowserRouter>
        <Analytics>
            <Switch>
                <Route exact path={"/"} component={HomePage} />
                <Route exact path={"/tickets/new"} component={NewTicketPage} />
                <Route exact path={"/ticket/:ticketId"} component={TicketPage} />
            </Switch>
        </Analytics>
    </BrowserRouter>
);

export default Routes;
